module.exports = __webpack_public_path__ + "img/_dialer_horiz.648f4e4c.svg";